<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Neuer Mandant</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="tenantForm" novalidate>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTTENANTNAME'] | translate}}" formControlName="name" required>
                        <!-- <button mat-button color="primary" matSuffix mat-icon-button  (click)="add()">
                            <mat-icon>add</mat-icon>
                        </button> -->
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button (click)="cancel()" >
                    <mat-icon>close</mat-icon>
                </button>
                <span style="flex: 1 1 auto"></span>
                <button matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}" mat-button (click)="add()">
                    <mat-icon>add</mat-icon>
                </button> -->
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}"
                                    (click)="add()" >Hinzufügen</button>
                </a>                   

            </div>    
          </form>
    </div>
</div>